export const nl = {
  pages: {
    home: {
      title: "Startpagina",
      start: "Begin",
    },
  },
};
